import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { LoadingIndicator } from "../../../components/loading-indicator.component";
import { useLoadData } from "../../../hooks/useLoadData";
import { ApiResponse } from "../../../models/api-response";
import { usersApiKeyStore } from "../../../api/users-api-key-store";

interface EmployeeFilter {
    value?: any;
    onChange: (type: any, value: any) => void;
}
export const EmployeeFilter=({value,onChange}:EmployeeFilter)=>{

    const { data, isLoading } = useLoadData<ApiResponse<any>>(usersApiKeyStore.getUsers());
    return(
        <>
            <LoadingIndicator isLoading={isLoading} />
            <FormControl fullWidth>
                <InputLabel size="small" id="demo-simple-select-label">Employee</InputLabel>
                <Select
                    size="small"
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={value}
                    label="Employee"
                    onChange={(event) => onChange("requestedBy", event.target.value)}
                >
                    <MenuItem value=""><em>NONE</em></MenuItem>

                    {
                        data &&
                        data?.data.map((o: any) => (
                            <MenuItem key={`${o.userID}-${o.userName}`} value={o.userID}>{o.userName}</MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
        </>
    );
}